/**
 * 属性元数据存储
 * Property metadata storage
 */
const metadataStorage = new WeakMap();
// 使用 Symbol.for 创建全局 Symbol，确保跨包共享元数据
// Use Symbol.for to create a global Symbol to ensure metadata sharing across packages
export const PROPERTY_METADATA = Symbol.for('@esengine/property:metadata');
/**
 * 属性装饰器 - 声明组件属性的编辑器元数据
 *
 * @example
 * ```typescript
 * @ECSComponent('Transform')
 * export class TransformComponent extends Component {
 *     @Property({ type: 'vector3', label: 'Position' })
 *     public position: Vector3 = { x: 0, y: 0, z: 0 };
 *
 *     @Property({ type: 'number', label: 'Speed', min: 0, max: 100 })
 *     public speed: number = 10;
 * }
 * ```
 */
export function Property(options) {
    return (target, propertyKey) => {
        const constructor = target.constructor;
        const existingMetadata = metadataStorage.get(constructor) || {};
        existingMetadata[propertyKey] = options;
        metadataStorage.set(constructor, existingMetadata);
    };
}
/**
 * 获取组件类的所有属性元数据
 * Get all property metadata for a component class
 */
export function getPropertyMetadata(target) {
    return metadataStorage.get(target);
}
/**
 * 检查组件类是否有属性元数据
 * Check if a component class has property metadata
 */
export function hasPropertyMetadata(target) {
    return metadataStorage.has(target);
}
//# sourceMappingURL=PropertyDecorator.js.map